import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-failed",
  "use": "icon-failed-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-failed\"><path clip-rule=\"evenodd\" d=\"m5 9c2.20914 0 4-1.79086 4-4s-1.79086-4-4-4-4 1.79086-4 4 1.79086 4 4 4zm.375-3.09086.125-2.90914h-1l.125 2.90914zm.125 1.09086c0 .27614-.22386.5-.5.5s-.5-.22386-.5-.5.22386-.5.5-.5.5.22386.5.5z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol